// @flow
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {Dialog, DialogContent, DialogHeader} from 'sail/Dialog';
import {Title} from 'sail/Text';
import ModalLayer from 'sail/ModalLayer';
import {Executable} from './_executable';
import {
  DEV_TOOLS,
  DeveloperToolsCsat,
} from '../../DeveloperToolsCsat/DeveloperToolsCsat';

const messages = defineMessages({
  feedbackPromptLabel: {
    id: 'docsApp.clui.feedbackPromptLabel',
    description: 'Label shown when the user first opens the feedback form.',
    defaultMessage: 'Feedback on this experience:',
  },
  optionalResponsePlaceholder: {
    id: 'docsApp.clui.optionalResponseLabel',
    description:
      'Placeholder shown in the textarea for an optional freeform response.',
    defaultMessage: 'Optional response...',
  },
  feedbackTitle: {
    id: 'docsApp.clui.feedbackTitle',
    description: 'Title of the dialog which displays csat form.',
    defaultMessage: 'Feedback on your developer experience',
  },
  feedbackClose: {
    id: 'docsApp.clui.feedbackClose',
    description: 'Label for the action to close the csat form',
    defaultMessage: 'Close',
  },
  feedbackToolTip: {
    id: 'docsApp.clui.feedbackToolTip',
    description: 'Label for the feedback tool tip',
    defaultMessage: 'Feedback',
  },
  submitLabel: {
    id: 'docsApp.clui.submitLabel',
    description: 'Label text on the action to submit the feedback form.',
    defaultMessage: 'Submit',
  },
  cancelLabel: {
    id: 'docsApp.clui.cancelLabel',
    description: 'Label text on the action to cancel the feedback form.',
    defaultMessage: 'Cancel',
  },
});

const Feedback = () => {
  const {formatMessage} = useIntl();

  const [isVisible, setVisible] = React.useState(true);

  return (
    <ModalLayer
      shown={isVisible}
      onWashClick={() => setVisible(false)}
      onEscape={() => setVisible(false)}
    >
      <Dialog width="645px">
        <DialogHeader
          title={<Title>{formatMessage(messages.feedbackTitle)}</Title>}
          closeLabel={formatMessage(messages.feedbackClose)}
          onClose={() => setVisible(false)}
        />
        <DialogContent padding={20}>
          <DeveloperToolsCsat
            devTool={DEV_TOOLS.STRIPE_SHELL}
            onClose={() => setVisible(false)}
          />
        </DialogContent>
      </Dialog>
    </ModalLayer>
  );
};

export class feedback extends Executable {
  commandName(): string {
    return 'feedback';
  }

  help(): React.Node {
    this.setAllowInput(true);
    return 'please tell us about your experience with Stripe Shell';
  }

  run(): React.Node {
    this.setAllowInput(true);
    return <Feedback />;
  }
}
